import { EQuizModeEmojiIcon } from '@constants';
import { IQuizResult } from '@sdk/contracts';
import { Progress } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import {
  CourseName,
  IconWrapper,
  InfoWrapper,
  NumberWrapper,
  PercentageWrapper,
  Title,
  Type,
  Wrapper
} from './QuizResultCard.styles';

import { Box } from '@/components/Utils';
const PROGRESS_SIZE = 48;

export const QuizResultCard = ({ quizResult }: { quizResult: IQuizResult }) => {
  const { t } = useTranslation('StudentQuizTranslations');
  const { colors } = useTheme();
  const navigateTo = useNavigate();
  const { color, backgroundColor } = useMemo(() => {
    if (quizResult.score >= 7.5) {
      return {
        color: colors.green6,
        backgroundColor: colors.green3
      };
    }
    if (quizResult.score >= 5) {
      return {
        color: colors.orange6,
        backgroundColor: colors.orange3
      };
    }
    if (quizResult.score > 0) {
      return {
        color: colors.red6,
        backgroundColor: colors.red3
      };
    }
    return {
      color: colors.black7,
      backgroundColor: colors.black3
    };
  }, [quizResult]);

  const handleClick = () => {
    navigateTo(`/tests/results/${quizResult._id}`);
  };

  return (
    <Wrapper onClick={handleClick}>
      <Type>
        <IconWrapper>{EQuizModeEmojiIcon[quizResult.studentQuiz.mode]}</IconWrapper>
        {t(quizResult.studentQuiz.mode)}
      </Type>
      <InfoWrapper>
        <Box flexDirection="column" gap={4}>
          <Title>{quizResult.studentQuiz.title}</Title>
          <CourseName>{quizResult.studentQuiz.course.name}</CourseName>
        </Box>
        <Progress
          type="circle"
          strokeColor={color}
          strokeWidth={10}
          trailColor={backgroundColor}
          percent={Math.round(quizResult.score * 10)}
          size={PROGRESS_SIZE}
          format={label => (
            <NumberWrapper>
              {label}
              <PercentageWrapper>%</PercentageWrapper>
            </NumberWrapper>
          )}
        />
      </InfoWrapper>
    </Wrapper>
  );
};
